/* eslint-disable @typescript-eslint/no-magic-numbers */
import '@testing-library/jest-dom';
import { render, screen, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import { useState } from 'react';

import { VarIndicator } from './VarIndicator';

const LABELS = {
  DRAFT: 'Concept',
  REJECTED: 'Concept',
  SUBMITTED: 'Verificatie',
  ACTIVE: 'Actief',
};

jest.mock('components/Icon', () => ({
  Icon: ({ name }: { name: string }) => <svg data-testid={name} />,
}));

const TestWrapper = () => {
  const [currentStep, setCurrentStep] = useState(1);
  return (
    // When clicked the onClick callback updates currentStep from 1 to 2.
    <VarIndicator
      label={LABELS}
      variant="SUBMITTED"
      maxSteps={3}
      currentStep={currentStep}
      onClick={() => setCurrentStep(2)}
    />
  );
};

describe('VarIndicator', () => {
  const onClickSpy = jest.fn();

  beforeEach(() => {
    onClickSpy.mockClear();
  });

  it('should render Concept (DRAFT)', () => {
    render(<VarIndicator label={LABELS} variant="DRAFT" />);
    expect(screen.getByText('Concept')).toBeInTheDocument();
  });

  it('should render Concept (REJECTED)', () => {
    render(<VarIndicator label={LABELS} variant="REJECTED" />);
    expect(screen.getByText('Concept')).toBeInTheDocument();
  });

  it('should render Concept (ACTIVE)', () => {
    render(<VarIndicator label={LABELS} variant="ACTIVE" />);
    expect(screen.getByText('Actief')).toBeInTheDocument();
  });

  it('should render dots (SUBMITTED)', () => {
    render(<VarIndicator label={LABELS} variant="SUBMITTED" maxSteps={3} currentStep={0} />);
    expect(screen.getByText('Verificatie')).toBeInTheDocument();
    expect(screen.getAllByTestId('CircleSmall')).toHaveLength(3);
    expect(screen.queryByTestId('CircleSmallFilled')).not.toBeInTheDocument();
  });

  it('should render filled dots when currentStep != 0 (SUBMITTED)', () => {
    render(<VarIndicator label={LABELS} variant="SUBMITTED" maxSteps={3} currentStep={1} onClick={onClickSpy} />);
    const verificationButton = screen.getByText('Verificatie');
    expect(verificationButton).toBeInTheDocument();
    expect(screen.getAllByTestId('CircleSmallFilled')).toHaveLength(1);
    expect(screen.getAllByTestId('CircleSmall')).toHaveLength(2);
  });

  it('should render filled dots currentStep is updated (SUBMITTED)', async () => {
    render(<TestWrapper />);
    expect(screen.getAllByTestId('CircleSmallFilled')).toHaveLength(1);
    expect(screen.getAllByTestId('CircleSmall')).toHaveLength(2);
    const verificationButton = screen.getByText('Verificatie');
    await userEvent.click(verificationButton);
    await waitFor(() => {
      expect(screen.getAllByTestId('CircleSmallFilled')).toHaveLength(2);
    });
    await waitFor(() => {
      expect(screen.getAllByTestId('CircleSmall')).toHaveLength(1);
    });
  });
});
